var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMusicgenresicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3385",
    "data-name": "Group 3385",
    transform: "translate(-773.238 -3025.643)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_318",
    "data-name": "Ellipse 318",
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    transform: "translate(773.238 3025.643)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3398",
    "data-name": "Group 3398",
    transform: "translate(790.016 3038.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4758",
    "data-name": "Path 4758",
    d: "M-452.732,468.665a12.368,12.368,0,0,1,1.5-5.954,12.572,12.572,0,0,1,7.717-6.221.847.847,0,0,1,.5.025,8.478,8.478,0,0,0,5.922.021,1.076,1.076,0,0,1,.65-.015,12.509,12.509,0,0,1,8.966,10.207c.119.625.128,1.271.191,1.938Z",
    transform: "translate(452.732 -435.887)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4759",
    "data-name": "Path 4759",
    d: "M-341.763,257.245a5.858,5.858,0,0,1-5.865-5.847,5.879,5.879,0,0,1,5.864-5.858,5.876,5.876,0,0,1,5.849,5.841A5.857,5.857,0,0,1-341.763,257.245Z",
    transform: "translate(354.477 -238.708)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4760",
    "data-name": "Path 4760",
    d: "M-435.758,151.417c.329.006.566.055.682-.305.048-.147.327-.277.518-.307a4.752,4.752,0,0,1,.975-.01.571.571,0,0,1,.6.625q.007,2.395,0,4.789a.567.567,0,0,1-.583.608c-.336.015-.674.013-1.01,0a.628.628,0,0,1-.556-.387.449.449,0,0,0-.29-.224,2.445,2.445,0,0,1-1.694-3.873.756.756,0,0,0,.1-.424,10.781,10.781,0,0,1,1.553-5.734,10.811,10.811,0,0,1,8.084-5.371,11.087,11.087,0,0,1,12.42,8.811c.154.76.15,1.551.23,2.326a.988.988,0,0,0,.137.445,2.42,2.42,0,0,1-1.748,3.8.39.39,0,0,0-.266.2.568.568,0,0,1-.539.4c-.358.007-.717.014-1.074,0a.527.527,0,0,1-.542-.568q-.009-2.427,0-4.854a.548.548,0,0,1,.577-.574,7.407,7.407,0,0,1,1.041.01c.162.018.41.131.446.252.1.355.356.344.69.354a9.457,9.457,0,0,0-3.7-7.249,9.424,9.424,0,0,0-10.713-1.04A9.628,9.628,0,0,0-435.758,151.417Z",
    transform: "translate(438.579 -140.699)",
    fill: "#febaba"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicgenresicon);
export default __webpack_public_path__ + "static/media/musicgenresicon.87d07ad4f3d3261a53ababcb3894f2d4.svg";
export { ForwardRef as ReactComponent };